// extracted by mini-css-extract-plugin
export var icon = "_qg-0";